export default __webpack_public_path__ + "static/media/P10018.265be779.png";